module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"events":"События","questions":"Вопросы","connectWithCandidate":"Связь с кандидатом","testing":"Тестирование"}}')
  delete Component.options._Ctor
}
